export enum PartitionType {
    base = 'base',
    invest = 'invest',
    funding = 'funding',
    simulationFile = 'simulationFile',
    other = 'other'
}
